import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { formatCurrency } from "../../config/global";
import { useAppSelector } from "../../core/feature/hooks";
import TabsMobile from "../__template/TabsMobileComponent";

import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import info from "../../assets/images/icon_home/info.svg";

import bsi from "../../assets/images/icon_topup/bsi.svg";
import Alfa from "../../assets/images/icon_topup/Alfa.svg";
import bankJatim from "../../assets/images/icon_topup/bankJatim.svg";
import bankntb from "../../assets/images/icon_topup/bankntb.svg";
import bankntbsy from "../../assets/images/icon_topup/bankntbsy.svg";
import bca from "../../assets/images/icon_topup/bca.svg";
import bjb from "../../assets/images/icon_topup/bjb.svg";
import bjbs from "../../assets/images/icon_topup/bjbs.svg";
import kbbs from "../../assets/images/icon_topup/kbbs.png";
import bsb from "../../assets/images/icon_topup/bsb.svg";
import bsbs from "../../assets/images/icon_topup/bsbs.svg";
import xendit from "../../assets/images/icon_topup/xendit.svg";
import bnis from "../../assets/images/icon_topup/bnis.svg";
import bri from "../../assets/images/icon_topup/bri.svg";
import btpn from "../../assets/images/icon_topup/btpn.svg";
import cimb from "../../assets/images/icon_topup/cimb.svg";
import cimbsyariah from "../../assets/images/icon_topup/cimbsyariah.png";
import dana from "../../assets/images/icon_topup/dana.svg";
import danamon from "../../assets/images/icon_topup/danamon.svg";
import indo from "../../assets/images/idnassets/merchant/indomaret.png";
import linkaja from "../../assets/images/icon_topup/linkaja.svg";
import mandiri from "../../assets/images/icon_topup/mandiri.svg";
import maybank from "../../assets/images/icon_topup/maybank.svg";
import muamalat from "../../assets/images/icon_topup/muamalat.svg";
import idn from "../../assets/images/icon_topup/idn.svg";
import nobu from "../../assets/images/icon_topup/nobu.svg";
import ocbc from "../../assets/images/icon_topup/ocbc.svg";
import ovo from "../../assets/images/icon_topup/ovo.svg";
import permatasyariah from "../../assets/images/icon_topup/permatasyariah.svg";
import shopee from "../../assets/images/icon_topup/shopee.svg";
import bjs from "../../assets/images/icon_topup/bjs.svg";
import bni from "../../assets/images/icon_topup/bni.svg";
import permata from "../../assets/images/icon_topup/permata.svg";
import bntb from "../../assets/images/icon_topup/btn.svg";
import arrow from "../../assets/images/icon_tab/arrow-bottom.svg";
import copy from "../../assets/images/icon_topup/copy.svg";
import tkiLogo from "../../assets/images/logo-company.svg";
import gojek from "../../assets/images/idnassets/merchant/gopay.png";
import tokped from "../../assets/images/idnassets/merchant/tokopedia.png";
import blibli from "../../assets/images/idnassets/merchant/blibli.png";
import bayarind from "../../assets/images/idnassets/merchant/bayarind.png";
import kaspro from "../../assets/images/idnassets/merchant/kaspro.png";
import Ayopop from "../../assets/images/idnassets/merchant/ayopop.png";
import mobilepulsa from "../../assets/images/idnassets/merchant/mobilepulsa.png";

import _, { bind, create } from "lodash";
import { LazyLoadImage } from "react-lazy-load-image-component";

import "react-spring-bottom-sheet/dist/style.css";
import * as API from "../../core/service/api.js";
import { BottomSheet } from "react-spring-bottom-sheet";
import User from "../../core/models/user";
import { faKipSign } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import {
  createVa,
  getAllCreatedVa,
  paymentIdn,
} from "../../core/service/api_topup";
import { useDispatch } from "react-redux";
import { setUser } from "../../core/feature/user/userSlice";
import CustomApp from "../../core/models/customApp";
import { Dialog, Transition } from "@headlessui/react";
import { createAction } from "@reduxjs/toolkit";
import { isDarkColor } from "../../config/DarkColorChecker";
import CurrencyInput from "react-currency-input-field";
import {
  getBankDisplayIcon,
  getBankDisplayName,
  sortTopupBanks,
} from "./topupBankUtils";
const ComponentTopup = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  let company = JSON.parse(String(localStorage.getItem("company")));
  const getBalance = useMemo(() => formatCurrency(balance), [balance]);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const [dataVA, setDataVA] = useState<any>([]);
  const [va, setVa] = useState<any>({});
  const [selectedData, setSelectedData] = useState<any>({});
  const navigate = useNavigate();
  const { t } = useTranslation();
  let [isOpen, setIsOpen] = useState(false);

  let [openInputAmount, setOpenInput] = useState(false);
  const [amount, setAmount] = useState(0);
  const [errAmount, setErrAmount] = useState("");
  const [succesCreate, setSuccesCreate] = useState(false);
  const [idn, setIdn] = useState(false);
  const [tempMetode, setTempMetode] = useState<any>({});
  const [imagePreview, setImagePreview] = useState<any>();
  const [openPreview, setopenPreview] = useState(false);

  const [idnVa, setIdnVa] = useState<any>({});
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const dataBank = [
    {
      initial: "TKI",
      name: "Teknologi Kartu Indonesia",
      adminBank: "",
      icon: tkiLogo,
    },
    {
      initial: "XENDIT BNI",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI SNAP",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI-SNAP",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI OGP",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI 46",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI SYARIAH",
      name: "Bank BNI Syariah",
      adminBank: "",
      icon: bnis,
    },
    {
      initial: "BANKJATIM",
      name: "Bank Jatim Syariah",
      adminBank: "",
      icon: bjs,
    },
    {
      initial: "BANKJATIM OVERBOOK",
      name: "Bank Jatim Syariah",
      adminBank: "",
      icon: bjs,
    },
    {
      initial: "XENDIT BSI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "TKIPAYBSI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI-MAKARA",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI-SBI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI-CMS",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "NTB SYARIAH",
      name: "Bank Ntb Syariah",
      adminBank: "",
      icon: bankntbsy,
    },
    {
      initial: "MUAMALAT",
      name: "Bank Muamalat",
      adminBank: "",
      icon: muamalat,
    },
    {
      initial: "XENDIT BCA",
      name: "Bank Central Asia",
      adminBank: "",
      icon: bca,
    },
    {
      initial: "BCA",
      name: "Bank Central Asia",
      adminBank: "",
      icon: bca,
    },
    {
      initial: "XENDIT BRI",
      name: "Bank Rakyat Indonesia",
      adminBank: "",
      icon: bri,
    },
    {
      initial: "XENDIT MANDIRI",
      name: "Bank Mandiri",
      adminBank: "",
      icon: mandiri,
    },
    {
      initial: "MANDIRI",
      name: "Bank Mandiri",
      adminBank: "",
      icon: mandiri,
    },
    {
      initial: "XENDIT PERMATA",
      name: "Bank Permata",
      adminBank: "",
      icon: permata,
    },
    {
      initial: "PERMATA SYARIAH",
      name: "Bank Permata Syariah",
      adminBank: "",
      icon: permata,
    },
    {
      initial: "BTN",
      name: "Bank Tabungan Negara",
      adminBank: "",
      icon: btpn,
    },
    {
      initial: "XENDIT BJB",
      name: "Bank BJB",
      adminBank: "",
      icon: bjb,
    },
    {
      initial: "BTPN",
      name: "Bank BTPN",
      adminBank: "",
      icon: btpn,
    },
    {
      initial: "XENDIT CIMB",
      name: "Bank CIMB Niaga",
      adminBank: "",
      icon: cimb,
    },
    {
      initial: "PRISMALINK CIMB",
      name: "Bank CIMB Syariah",
      adminBank: "",
      icon: cimbsyariah,
    },
    {
      initial: "DANAMON",
      name: "Bank Danamon",
      adminBank: "",
      icon: danamon,
    },
    {
      initial: "MAYBANK",
      name: "Bank Maybank",
      adminBank: "",
      icon: maybank,
    },
    {
      initial: "OCBC",
      name: "Bank OCBC NISP",
      adminBank: "",
      icon: ocbc,
    },
    {
      initial: "XENDIT DISBURSEMENT",
      name: "Xendit DISBURSEMENT",
      adminBank: "",
      icon: xendit,
    },
    {
      initial: "BRI",
      name: "Bank Rakyat Indonesia",
      adminBank: "",
      icon: bri,
    },
    {
      initial: "BJB SYARIAH",
      name: "Bank BJB Syariah",
      adminBank: "",
      icon: bjbs,
    },
    {
      initial: "KBBS",
      name: "KB Bank Syariah",
      adminBank: "",
      icon: kbbs,
    },
    {
      initial: "SUMSELBABEL",
      name: "Bank Sumsel Babel Syariah",
      adminBank: "",
      icon: bsbs,
    },
    {
      initial: "SUMSELBABEL SYARIAH",
      name: "Bank Sumsel Babel Syariah",
      adminBank: "",
      icon: bsbs,
    },
    {
      initial: "NOBU",
      name: "Bank Nobu",
      adminBank: "",
      icon: nobu,
    },
  ];
  const topUpIdn = [
    {
      active: false,
      name: "Indomaret",
      image: indo,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cashier.png"),
          name: "LANGKAH 1 PAYMENT POINT",
          information:
            "Informasikan kepada kasir akan melakukan pembayaran Payment Point",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_select.png"),
          name: "LANGKAH 2 VALIDASI",
          information:
            "Sebutkan Nama Sekolah dan Nomor Induk Siswa Anda kepada kasir.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cards.png"),
          name: "LANGKAH 3 PEMBAYARAN",
          information:
            "Detail tagihan akan ada pada layar Kasir. Lakukan pembayaran ke Kasir sejumlah nominal yang disebutkan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_receipt.png"),
          name: "LANGKAH 4 SELESAI",
          information:
            "Anda akan menerima struk pembayaran sebagai bukti transaksi berhasil. Notifikasi pembayaran juga akan langsung diterima oleh Institusi Pendidikan",
        },
      ],
    },
    {
      active: true,
      name: "Alfamart",
      image: Alfa,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cashier.png"),
          name: "LANGKAH 1 INFORMASI",
          information:
            "Informasikan kepada kasir akan melakukan pembayaran Jaringan IDN, kemudian sebutkan Kode IDN dan NIS (Nomor Induk Siswa / Mahasiswa). replaceBranchCode replaceNis",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_select.png"),
          name: "LANGKAH 2 VALIDASI",
          information:
            "Pastikan data yang kasir informasikan valid dan total tagihan benar.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cards.png"),
          name: "LANGKAH 3 PEMBAYARAN",
          information:
            "Bayar sejumlah nominal dengan menggunakan tunai atau non tunai.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_receipt.png"),
          name: "LANGKAH 4 SELESAI",
          information:
            "Anda akan menerima struk pembayaran sebagai bukti transaksi berhasil.",
        },
      ],
    },

    {
      active: true,
      name: "Gopay",
      image: gojek,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen01.png"),
          name: "LANGKAH 1 PILIH GO-BILLS",
          information: "Pada aplikasi Gojek, pilih menu GO-BILLS",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen02.png"),
          name: "LANGKAH 2 PILIH MENU SEKOLAH",
          information: "Di halaman GO-BILLS,pilih menu Schools.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen03.png"),
          name: "LANGKAH 3 CARI SEKOLAH",
          information: "Gunakan Institusi TKI(Teknologi Kartu Indonesia)",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/gopay/gopay_screen05.png"),
          name: "LANGKAH 4 MASUKAN NIS/NIM",
          information: "Masukan NIS/NIM Anda replaceNis pada kolom ID Pelajar.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen06.png"),
          name: "LANGKAH 5 KONFIRMASI",
          information:
            "Pastikan data tagihan sudah benar, lalu lakukan pembayaran dengan GO-PAY.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen07.png"),
          name: "LANGKAH 6 SELESAI",
          information:
            "Pembayaran Selesai. Anda dapat menyimpan atau mengirimkan bukti pembayaran dengan menekan tombol Send Receipt.",
        },
      ],
    },
    {
      active: true,
      name: "Tokopedia",
      image: tokped,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen01.png"),
          name: "LANGKAH 1 PILIH TOPUP & TAGIHAN",
          information: "Pada aplikasi Tokopedia,pilih menu Topup & Tagihan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen02.png"),
          name: "LANGKAH 2 PILIH BIAYA PENDIDIKAN",
          information:
            "Di halaman Topup & Tagihan,pilih menu Biaya Pendidikan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen03.png"),
          name: "LANGKAH 3 PILIH JENIS LEMBAGA PENDIDIKAN",
          information: "Pilih Cluster yang terdiri dari Kursus.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen04.png"),
          name: "LANGKAH 4PILIH INSTITUSI",
          information:
            "Pilih Institusi TKI(Teknologi Kartu Indonesia) pada kolom operator.",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen05.png"),
          name: "LANGKAH 5 MASUKAN NIS/NIM",
          information:
            "Masukkan NIS/NIM replaceNis pada Nomor Pembayaran / Nomor Mahasiswa lalu klik cek tagihan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen06.png"),
          name: "LANGKAH 6 KONFIRMASI",
          information:
            "Pastikan data tagihan sudah benar serta Ikuti langkah pembayaran dari akun Tokopedia Anda.",
        },
      ],
    },
    {
      active: true,
      name: "Blibli",
      image: blibli,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen01.png"),
          name: "LANGKAH 1 MENU PENDIDIKAN",
          information: "Pada aplikasi/web Blibli, pilih menu Pendidikan",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen02.png"),
          name: "LANGKAH 2 TIPE PILIH INSTITUSI",
          information:
            "Di halaman Pendidikan, pilih Nama Institusi TKI (Teknologi Kartu Indonesia)",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen03.png"),
          name: "LANGKAH 3 MASUKAN NIS/NIM",
          information:
            "Tagihan akan muncul setelah memasukan NIS/NIM replaceNis.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen03.png"),
          name: "LANGKAH 4 KONFIRMASI",
          information:
            "Periksa kembali semua data tagihan yang muncul sebelum lanjut ke pembayaran.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen05.png"),
          name: "LANGKAH 5 METODE PEMBAYARAN",
          information:
            "Pilih metode pembayaran yang Anda inginkan, lalu klik tombol “Bayar Sekarang.",
        },
      ],
    },
    // {
    //   "active": false,
    //   "name": "Bayarind",
    //   "image": bayarind,
    //   "children": [
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen01.png"),
    //       "name": "LANGKAH 1 PILIH SEE ALL",
    //       "information": "Pada aplikasi Bayarind pilih menu “See All”."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen02.png"),
    //       "name": "LANGKAH 2 PILIH MENU EDUKASI",
    //       "information": "Pada halaman Category, pilih “Edukasi”"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen03.png"),
    //       "name": "LANGKAH 3 PILIH SEKOLAH",
    //       "information": "Pilih Institusi Pendidikan yang anda tuju."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen04.png"),
    //       "name": "LANGKAH 4 MASUKAN NIS/NIM",
    //       "information": "Lalu masukan NIS/NIM pada kolom yang tersedia."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen05.png"),
    //       "name": "LANGKAH 5 PILIH TAGIHAN",
    //       "information": "Anda dapat memilih seluruh tagihan atau pilih yang ingin Anda bayarkan."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen06.png"),
    //       "name": "LANGKAH 6 KONFIRMASI",
    //       "information": "Pastikan total tagihan (berikut admin fee) yang ingin anda bayarkan sudah sesuai."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen07.png"),
    //       "name": "LANGKAH 7 METODE PEMBAYARAN",
    //       "information": "Anda dapat memilih metode pembayaran dengan Bayarind atau Oneklik."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen08.png"),
    //       "name": "LANGKAH 8 PIN",
    //       "information": "Masukan PIN dan akan otomatis ke pembayaran."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen09.png"),
    //       "name": "LANGKAH 9 SELESAI",
    //       "information": "Pembayaran Selesai"
    //     }
    //   ]
    // },
    // {
    //   "active": false,
    //   "name": "Kaspro",
    //   "image": kaspro,
    //   "children": [
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen01.png"),
    //       "name": "LANGKAH 1 PILIH MENU PEMBAYARAN",
    //       "information": "Setelah men-download aplikasi, lakukan login, dan pilih Bill & Voucher"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen02.png"),
    //       "name": "LANGKAH 2 PILIH MENU SEKOLAH",
    //       "information": "Kemudian pilih menu School."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen03.png"),
    //       "name": "LANGKAH 3 DETIL SISWA",
    //       "information": "Masukan Kode Sekolah pada kolom IDN Code (lihat disini) dan Nomor Induk Siswa"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen04.png"),
    //       "name": "LANGKAH 4 PILIH TAGIHAN",
    //       "information": "Setelah muncul tagihan siswa, Anda dapat memilih tagihan yang ingin dibayarkan. Lalu klik Next."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen05.png"),
    //       "name": "LANGKAH 5 KONFIRMASI TAGIHAN",
    //       "information": "Pastikan data tagihan yang muncul sudah sesuai."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen06.png"),
    //       "name": "LANGKAH 6 KEAMANAN TRANSAKSI",
    //       "information": "Untuk keamanan bertransaksi, Anda harus memasukan PIN yang diminta oleh aplikasi."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen07.png"),
    //       "name": "LANGKAH 7 SELESAI",
    //       "information": "Transaksi selesai. Anda dapat menyimpan bukti pembayaran."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen08.png"),
    //       "name": "LANGKAH 8 NOTIFIKASI",
    //       "information": "Selain bukti transaksi di dalam aplikasi, anda juga akan mendapatkan notifikasi SMS."
    //     }
    //   ]
    // },
    {
      active: false,
      name: "Ayopop",
      image: Ayopop,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen01.png"),
          name: "LANGKAH 1 PILIH MENU PENDIDIKAN",
          information:
            "Setelah men-download aplikasi, lakukan login, dan pilih Pendidikan (download di Google Play atau App Store)",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen02.png"),
          name: "LANGKAH 2 PILIH SEKOLAH",
          information: "Kemudian pilih menu School.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen03.png"),
          name: "LANGKAH 3 MASUKAN NIS/NIM",
          information: "Masukan Nomor Induk Siswa Anda",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen04.png"),
          name: "LANGKAH 4 TAGIHAN",
          information:
            "Setelah muncul tagihan siswa klik LANJUT KE PEMBAYARAN.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen05.png"),
          name: "LANGKAH 5 PILIH METODE PEMBAYARAN",
          information:
            "Pilih metode pembayaran yang anda inginkan (Transfer, Kredit, Retail, Virtual Account, e-Cash).",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen06.png"),
          name: "LANGKAH 6 SELESAI",
          information: "Simpan bukti pembayaran anda.",
        },
      ],
    },
    // {
    //   "active": false,
    //   "name": "Mobilepulsa",
    //   "image": mobilepulsa,
    //   "children": [
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay1.png"),
    //       "name": "LANGKAH 1 PILIH MENU",
    //       "information": "Pilih menu Tagihan, lalu pilih menu Pendidikan."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay2.png"),
    //       "name": "LANGKAH 2 KONFIRMASI",
    //       "information": "Kemudian pilih Sekolah Anda dan masukan NIS Anda."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay3.png"),
    //       "name": "LANGKAH 3 PEMBAYARAN",
    //       "information": "Halaman Ringkasan ditampilkan, pilih tagihan yang akan dibayarkan. Ikut petunjukan untuk melakukan pembayaran"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay4.png"),
    //       "name": "LANGKAH 4 SELESAI",
    //       "information": "Setelah selesai, Anda bisa Cek Notifikasi atau Download Struk."
    //     }
    //   ]
    // },
    {
      active: true,
      name: "Shopee",
      image: shopee,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen01.png"),
          name: "LANGKAH 1 BUKA APLIKASI Shopee",
          information:
            "Pada aplikasi shopee, pilih menu Pulsa, Tagihan & Hiburan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen02.png"),
          name: "LANGKAH 2 LIHAT BAGIAN TAGIHAN",
          information: "Pada bagian Bills, pilih menu BIAYA PENDIDIKAN.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen03.png"),
          name: "LANGKAH 3 PILIH INSTITUSI",
          information: "Tekan Pilih Institusi.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen04.png"),
          name: "LANGKAH 4 CARI INSTITUSI",
          information: "Gunakan Institusi TKI (Teknologi Kartu Indonesia)",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/shopee/shopee_screen05.png"),
          name: "LANGKAH 5 MASUKAN NOMOR PEMBAYARAN",
          information: "Masukkan Nomor Pembayaran atau Nomor Siswa replaceNis.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen06.png"),
          name: "LANGKAH 6 LIHAT TAGIHAN",
          information: "Tekan Lihat Tagihan untuk melanjutkan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen07.png"),
          name: "LANGKAH 7 KONFIRMASI",
          information: "Harap periksa dan konfirmasi detail pembayaran.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen08.png"),
          name: "LANGKAH 8 PEMBAYARAN",
          information: "Setelah melakukan konfirmasi, pilih metode pembayaran.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen09.png"),
          name: "LANGKAH 9 SELESAI",
          information:
            "Pembayaran Selesai. Pengguna dapat melihat detail transaksi.",
        },
      ],
    },
  ];
  function numberOnly(str: any) {
    return String(str).replace(/[^0-9.]/g, "");
  }
  function onDismiss() {
    setOpen(false);
  }

  const closeCreate = () => {
    setIsOpen(false);
  };

  const onCopy = useCallback(() => {
    setCopied(true);
    toast(t("TOPUP.VACopied"));
  }, []);

  const getVa = async (type: string) => {
    getAllCreatedVa().then((res) => {
      if (user.email == "alfian@test.com") {
        let alfianVA = [
          {
            bankName: "TKITKI",
            icon: tkiLogo,
            name: "BANK TKI",
            userName: "ALFIAN",
            vaNumber: "999001112222",
            adminBank: 1000,
          },
        ];
        let va = [
          {
            bankId: "6103c94e9470534b4d5d0f07",
            bankName: "TKITKI",
            number: "900571500006969",
            adminBank: 0.0,
          },
        ];
        setDataVA(alfianVA);
        setVa(va);
        return;
      }
      if (type == "create") {
        const userTemp = JSON.parse(String(localStorage.getItem("user_redux")));
        userTemp.accounts[0].vaNumbers = res.data.vaNumbers;

        dispatch(setUser(userTemp));
        setVa(res.data.vaNumbers);
        console.log(res.data.vaNumbers, "sss");

        let tempVA: any[] = [];

        for (var i = 0; i < company.banks.length; i++) {
          var bank = company?.banks[i];

          if (bank == "IDN") {
            //jika idn
            setIdn(true);
          }
          var temp = _.find(dataBank, {
            initial: bank,
          });
          var userBank = user.accounts.length ? _.find(user.accounts[0].vaNumbers, {
            bankName: bank,
          }) : {};

          if (temp) {
            tempVA.push({
              bankName: bank,
              icon: getBankDisplayIcon(bank, temp?.icon),
              name: getBankDisplayName(bank, temp?.name),
              userName: user?.name,
              vaNumber: userBank?.vaNumber,
              adminBank: userBank?.adminBank,
              originalName: temp?.name,
            });
          }
        }
        setDataVA(sortTopupBanks(tempVA));
        // window.location.
      } else {
        setVa(res.data.vaNumbers);
      }
    });
  };

  const setVas = (data: any) => {
    setSelectedData(data);
    var temp = user.accounts.length ? _.find(user.accounts[0].vaNumbers, {
      bankName: data.bankName,
    }) : {};

    var datava = data;

    if (user.email == "alfian@test.com") {
      setVa({
        bankName: "TKITKI",
        icon: tkiLogo,
        name: "BANK TKI",
        userName: "ALFIAN",
        vaNumber: "999001112222",
        adminBank: 1000,
      });
      setOpen(true);
      return;
    }
    if (temp == undefined) {
      setIsOpen(true);
    } else {
      datava["vaNumber"] = temp.number;
      datava["adminBank"] = temp.adminBank;

      setVa(datava);
      setOpen(true);
    }
  };
  const createVA = async () => {
    createVa(selectedData.bankName).then((res: any) => {
      setIsOpen(false);

      getVa("create");
      toast("va create");
    });
  };
  const openView = (e: any) => {
    setImagePreview(e);
    setopenPreview(true);
  };
  const handleSubmit = () => {
    if (amount <= 9999) {
      return setErrAmount("Input minimal Rp 10.000");
    }
    let query = {
      amount: amount,
    };
    paymentIdn(query)
      .then((resp) => {
        console.log(resp.data);
        setIdnVa(resp.data);
        setSuccesCreate(!succesCreate);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    let tempVA: any[] = [];

    for (var i = 0; i < company.banks.length; i++) {
      var bank = company?.banks[i];

      if (bank == "IDN") {
        //jika idn
      }
      var temp = _.find(dataBank, {
        initial: bank,
      });
      var userBank = user.accounts.length ? _.find(user.accounts[0].vaNumbers, {
        bankName: bank,
      }) : {};

      if (temp) {
        tempVA.push({
          bankName: bank,
          icon: getBankDisplayIcon(bank, temp?.icon),
          name: getBankDisplayName(bank, temp?.name),
          userName: user?.name,
          vaNumber: userBank?.vaNumber,
          adminBank: userBank?.adminBank,
          originalName: temp?.name,
        });
      }
    }
    console.log(company.banks, "banks");
    console.log(tempVA, "banks");

    setDataVA(sortTopupBanks(tempVA));
    getVa("create");
  }, []);

  return (
    <div className="h-full min-h-screen px-8 py-8 bg-psp-primary">
      <TabsMobile name={`${t("TOPUP.title")}`} backUrl={"home"}></TabsMobile>
      <section className="top-to-bottom">
        <div className="relative mt-6 mb-4">
          <div className="flex flex-row justify-between w-full p-3 bg-white shadow-lg rounded-2xl shadow-psp-primary">
            <div className="flex flex-col">
              <h1 className="m-0 text-xs font-medium text-black font-montserrat">
                {t("TOPUP.balance")}
              </h1>
              <p className="m-0 text-xl font-bold text-black font-montserrat">
                {getBalance}
              </p>

              <button
                onClick={() => navigate("/topup-history")}
                className={`flex flex-row gap-2  mt-2 px-3  py-2 font-medium rounded-full ${isDarkColor(customApp.app_accent_color)
                  ? "text-white"
                  : "text-black"
                  }`}
                style={{
                  fontSize: 9,
                  backgroundColor: customApp?.app_accent_color,
                }}
              >
                <img
                  src={info}
                  width={12}
                  className={`${isDarkColor(customApp.app_accent_color) ? "" : "invert"
                    }`}
                />
                {t("TOPUP.history")}
              </button>
            </div>
            <img src={dotBalance} alt="" />
          </div>
        </div>

        <div>
          <h1 className="my-4 text-sm font-semibold">{t("TOPUP.method")}</h1>
          <div className="flex flex-col gap-3">
            {dataVA.map((item: any) => (
              <div
                onClick={() => setVas(item)}
                className="grid items-center grid-cols-3 gap-4 p-3 bg-white rounded-xl"
              >
                <LazyLoadImage
                  className="max-h-5"
                  effect="blur"
                  src={item.icon}
                />
                <h1 className="col-span-2 m-0 text-xs font-normal  font-montserrat">
                  {item.name}
                </h1>
              </div>
            ))}
            {idn && (
              <>
                <h1 className="my-4 text-sm font-semibold">
                  {t("TOPUP.otherMetode")}
                </h1>
                {topUpIdn.map((item: any) => (
                  <div
                    onClick={() => {
                      setTempMetode(item);
                      setOpenInput(true);
                    }}
                    className="grid items-center grid-cols-3 gap-4 p-3 bg-white rounded-xl"
                  >
                    <LazyLoadImage
                      className="object-contain w-3/4 "
                      effect="blur"
                      src={item.image}
                    />
                    <h1 className="col-span-2 m-0 text-xs font-normal  font-montserrat">
                      {item.name}
                    </h1>
                  </div>
                ))}
              </>
            )}
          </div>
          {/* <h1 className="my-4 text-sm font-semibold">
            {" "}
            {t("TOPUP.otherMethod")}
          </h1>

          <div className="flex flex-row w-full px-4 py-3 bg-white rounded-lg">
            <span className="text-xs font-medium grow">
              {t("TOPUP.chooseOtherMethod")}
            </span>{" "}
            <img src={arrow} className="flex-0" alt="" />
          </div> */}
        </div>
      </section>
      <BottomSheet
        open={open}
        onDismiss={onDismiss}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={
          <h1 className="flex text-xl font-bold text-gray-800 items-left">
            <img src={va.icon} className="w-32 h-6" alt="" />
          </h1>
        }
        footer={
          <button
            onClick={() => {
              var CryptoJS = require("crypto-js");

              navigate("/topup-tutorial", {
                state: {
                  data: va,
                  va: va.vaNumber,
                },
              });
            }}
            style={{
              backgroundColor: customApp?.app_accent_color,
            }}
            className="w-full  active:bg-psp-active text-white py-2.5 text-sm font-semibold rounded-lg"
          >
            {t("TOPUP.tutorial")}
          </button>
        }
      >
        <div className="px-4 py-2">
          {/* <h1 className="text-lg font-semibold text-black">
            {t("TOPUP.accData")}
          </h1> */}
          <div className="grid grid-cols-3 gap-2 pb-2">
            <div className="flex flex-row ">
              <h1 className="text-xs font-normal font-montserrat">
                {t("TOPUP.bankName")}
              </h1>
            </div>
            <div className="flex flex-row col-span-2 gap-2 text-xs font-medium text-left text-black font-montserrat">
              <div>:</div>
              {va.name}
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2 pb-2">
            <div className="flex flex-row ">
              <h1 className="text-xs font-normal font-montserrat">
                {t("TOPUP.accName")}
              </h1>
            </div>
            <div
              className="flex flex-row col-span-2 gap-2 text-xs font-medium text-left text-black font-montserrat"
            >
              <div>:</div>
              {va.userName}
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2 pb-2">
            <div className="flex flex-row">
              <h1 className="text-xs font-normal font-montserrat">
                {t("TOPUP.bankAdmin")}
              </h1>
            </div>
            <div className="flex flex-row col-span-2 gap-2 text-xs font-medium text-left text-black font-montserrat">
              <div>:</div>
              {formatCurrency(String(va.adminBank).replace("-", ""))}
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2 pb-2">
            <div className="flex flex-row">
              <h1 className="text-xs font-normal font-montserrat">
                {t("TOPUP.accNumber")}
              </h1>
            </div>
            <div className="flex flex-row col-span-2 gap-2 text-xs font-medium text-left lining-nums">
              <div>:</div>
              <span className=" text-psp-primary oldstyle-nums">
                {va.vaNumber}
              </span>
              <CopyToClipboard onCopy={onCopy} text={va.vaNumber}>
                <img src={copy} className="w-3 h-3" alt="" />
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </BottomSheet>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeCreate}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("TOPUP.popupTitle")}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {t("TOPUP.popupDesc1") +
                        selectedData?.name +
                        " " +
                        t("TOPUP.popupDesc2")}
                    </p>
                  </div>

                  <div className="flex gap-2 mt-4">
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${isDarkColor(customApp.app_accent_color)
                        ? "text-white"
                        : "text-black"
                        }`}
                      onClick={() => createVA()}
                    >
                      {t("TOPUP.createAccount")}
                    </button>
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${isDarkColor(customApp.app_secondary_accent_color)
                        ? "text-white"
                        : "text-black"
                        }`}
                      onClick={() => closeCreate()}
                    >
                      {t("TOPUP.cancel")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={openInputAmount} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeCreate}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                  <button
                    className="absolute top-0 p-2 text-2xl text-gray-300 cursor-pointer right-2 "
                    onClick={() => {
                      setSuccesCreate(false);
                      setOpenInput(false);
                      setErrAmount("");
                      setTempMetode({});
                      setIdnVa({});
                      setAmount(0);
                    }}
                  >
                    x
                  </button>
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {"Top Up Merchant"}
                  </Dialog.Title>
                  <div className="mt-2">
                    <LazyLoadImage
                      className="object-contain w-1/4 "
                      effect="blur"
                      src={tempMetode?.image}
                    />
                    {!succesCreate ? (
                      <>
                        <Dialog.Title
                          as="h3"
                          className="text-base font-medium leading-6 text-gray-500"
                        >
                          {"Masukkan Jumlah"}
                        </Dialog.Title>
                        <CurrencyInput
                          className="w-full h-10 px-3 mb-2 border-solid rounded-xl border-1 border-psp-border-gray active:border-0"
                          placeholder="Rp.10.000"
                          decimalsLimit={2}
                          prefix={"Rp "}
                          value={numberOnly(amount)}
                          onValueChange={(value, name) => {
                            setAmount(value != undefined ? Number(value) : 0);
                            setErrAmount("");
                          }}
                        />
                        <p className="italic text-red">{errAmount}</p>
                      </>
                    ) : (
                      <div className="border-b-2">
                        <div>
                          <span className="font-semibold text-gray-400">
                            {"Nama Sekolah"}
                          </span>
                          <p>{idnVa?.companyName}</p>
                        </div>
                        <div className="my-1">
                          <span className="font-semibold text-gray-400">
                            {"NIS"}
                          </span>
                          <p>{idnVa.accountNumber}</p>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-400">
                            {"Jumlah Topup"}
                          </span>
                          <p>{formatCurrency(amount)}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  {succesCreate &&
                    tempMetode?.children?.map((item: any, ind: any) => (
                      <div key={ind} className="flex flex-row justify-between">
                        <div className="w-10/12">
                          <span>{item?.name}</span>
                          <p>{item?.information}</p>
                        </div>
                        <div className="w-2/12 h-auto">
                          <LazyLoadImage
                            onClick={() => {
                              openView(item?.image);
                            }}
                            className="items-center justify-center object-contain w-full cursor-pointer "
                            effect="blur"
                            src={item?.image}
                          />
                        </div>
                      </div>
                    ))}
                  <div className="flex gap-2 mt-4">
                    {!succesCreate && (
                      <button
                        type="button"
                        style={{
                          backgroundColor: customApp?.app_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                          }`}
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        {"Proses"}
                      </button>
                    )}

                    {/* <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${isDarkColor(customApp.app_secondary_accent_color) ? 'text-white' : 'text-black'}`}
                      onClick={() => {
                        setTempMetode({})
                        setOpenInput(false)
                        setIdnVa({})
                        setSuccesCreate(false)
                        setAmount(0)
                      }}
                    >
                      {t("TOPUP.cancel")}
                    </button> */}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={openPreview} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setopenPreview(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                  <button
                    className="absolute top-0 p-2 text-2xl text-gray-300 cursor-pointer right-2 "
                    onClick={() => {
                      setopenPreview(false);
                    }}
                  >
                    x
                  </button>
                  <div className="w-auto h-auto">
                    <LazyLoadImage
                      className="object-contain w-full "
                      effect="blur"
                      src={imagePreview}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default ComponentTopup;
